import { Topic } from "api/types";

export interface DisplayTopics {
	name: Topic;
	id: number;
	grade?: number;
}

export const topics: DisplayTopics[] = [
	{
		name: "Environment & Nature",
		id: 1,
	},
	{
		name: "Animals",
		id: 2,
	},
	{
		name: "Inventions",
		id: 3,
	},
	{
		name: "Space",
		id: 4,
	},
	{
		name: "Life & Evolution",
		id: 5,
	},
	{
		name: "Medicine & Health",
		id: 6,
	},
	{
		name: "Physics",
		id: 7,
	},
	{
		name: "Weather",
		id: 8,
	},
	{
		name: "Dinosaurs and Fossils",
		id: 9,
	},
	{
		name: "Mathematics",
		id: 10,
	},
];

// Convert Topics for fast lookup
export type TopicMap = {
	[key in Topic]: DisplayTopics;
};

export const topicMap = topics.reduce((acc, topic) => {
	acc[topic.name] = topic;
	return acc;
}, {} as TopicMap);
